module.exports = __webpack_public_path__ + "static/media/radiance.2f350a8b.png";